<template>
    <div>
        <label class="col-sm-4 lh40 text-lr"><i
                v-if=" Data.data.c_priority==='S'"
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
        <el-time-picker
                is-range
                @change="test"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                v-model="value"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围">
        </el-time-picker>
    </div>
</template>

<script>
export default {
    name: "time_range",
    props: [
        'Data',
    ],
    data() {
        return {
            value: this.Data.data.c_value === null ? ['08:00','18:00'] : this.Data.data.c_value.split(','),
         };
    },
    mounted() {
        this.$get_function(this.Data,this.value)//默认值
        },
    methods: {
        test(){
          var list={'start':this.value[0],'end':this.value[1]}
          this.$get_function(this.Data,list)
        }
    }
}
</script>

<style scoped>

</style>